import { Component, OnInit, Input } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuExhibitorSubMenuService } from 'app/components/menu-exhibitor-sub-menu/menu-exhibitor-sub-menu.service';
import { RolesService } from 'app/components/roles/roles.service';
import { UtilsService } from 'app/components/utils/utils.service';

@Component({
  selector: 'app-menu-exhibitor-sub-menu',
  templateUrl: './menu-exhibitor-sub-menu.component.html',
  styleUrls: ['./menu-exhibitor-sub-menu.component.css']
})
export class MenuExhibitorSubMenuComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Input() active: string = '';
  @Input() buttonTranslation: string = '';
  @Input() buttonLink: string = '';
  @Input() exhibitor: object = {
    name: ''
  };

  catalogueName: string|null = '';
  exhibitorId: string|null = '';

  constructor(public catalogueService: CatalogueService, private activatedRoute: ActivatedRoute, public menuExhibitorSubMenuService: MenuExhibitorSubMenuService,
  private router: Router, public rolesService: RolesService, public utilsService: UtilsService) {
    this.catalogueName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
  }

  goTo(url) {
    this.router.navigate([url]);
  }

  backToExhibitors() {
    this.router.navigate([this.catalogueName + '/exhibitor-backoffice/exhibitors']);
  }

  ngOnInit() {
  }

}
